<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :options="options" @optionsupdate="memopup">
            <Cwork :options="myoption" v-if="isload"></Cwork>
        </Cmember>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'work',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 5,
                options: {
                    hasoption: 1,
                    hasproject: 1,
                    hascourse: 1,
                    anycourse: false,
                    haskw: 0
                }
            };
        },
        components: {
            Cwork: () => import('@/components/Cwork')
        }
    }
</script>
